import axios from 'axios';
import type { IRestoreByIdsRequest, IRestoreByIdsResponse } from '@bb/contacts';

const restoreByIds = async (contactIds: string[]) => {
  const config: IRestoreByIdsRequest = {
    url: '/contacts/restore/contact',
    data: { ids: contactIds },
    method: 'post',
  };

  const { data } = await axios.request<IRestoreByIdsResponse>(config);

  return data;
};

export default restoreByIds;
